import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { ConversationFilters } from "../components/ConversationFilters";
import { ConversationItem } from "../components/common/ConversationItem";
import type { Conversation } from "../components/common/ConversationItem";
import { SkeletonLoader } from "../components/common/SkeletonLoader";
import { useListConversations } from "../hooks/useListConversations";

type Type = "all" | "circle_bot" | "live_chat" | "email";
type Status = "all" | "draft" | "closed" | "solved" | "open";

export const ConversationsListPage = () => {
  const [type, setType] = useState<Type>("all");
  const [status, setStatus] = useState<Status>("all");

  const { isLoading, data } = useListConversations({ type, status });

  const conversations = data?.conversations || [];

  const setFilters = (filters: { type: Type; status: Status }) => {
    setType(filters.type);
    setStatus(filters.status);
  };

  return (
    <div className="scrollbar-hide h-full overflow-auto">
      <Form
        preventAccidentalLeave
        id="conversations-filter-form"
        mode="onChange"
        onSubmit={() => {}}
        defaultValues={{
          type: "all",
          status: "all",
        }}
      >
        <ConversationFilters onFiltersChange={setFilters} />
      </Form>

      {isLoading && (
        <SkeletonLoader rows={4} height="52px" wrapperClassName="!px-0" />
      )}

      {conversations.length === 0 && (
        <div className="mt-4 flex flex-col">
          <div className="text-tertiary text-center text-sm">
            {t("help_widget.conversation_list_page.no_conversations")}
          </div>
        </div>
      )}

      <div className="flex flex-col px-4">
        {conversations.map((conversation: Conversation) => (
          <ConversationItem key={conversation.id} conversation={conversation} />
        ))}
      </div>
    </div>
  );
};
